import * as React from "react"
import PropTypes  from "prop-types"
import _          from "lodash"

export default class ModalChart extends React.Component {
	render() {
		const displayCharts = this.props.displayCharts

		return (
			<div className="modal is-active" style={{ zIndex: 103 }}>
				<div className="modal-background" onClick={this.props.onClickHideCharts} />
				<div className="modal-card">
					<header className="modal-card-head">
						<p className="modal-card-title">{this.props.title}</p>
						<button className="delete" aria-label="close" onClick={this.props.onClickHideCharts}></button>
					</header>
					<section className="modal-card-body">
						{this.props.tabs && !!this.props.tabs.length && (
						<nav className="tabs is-fullwidth">
							<ul>
								{_.map(this.props.tabs, (tab, i) => (
									<li className={(0 === i && true === displayCharts) || tab.id === displayCharts ? "is-active" : ""} key={i}>
										<a onClick={this.props.onClickChartModalTab.bind(this, tab.id)}>{tab.label}</a>
									</li>
								))}
							</ul>
						</nav>)}
						<div>
							{this.props.children}
						</div>
					</section>
				</div>
			</div>
		)
	}
}

ModalChart.propTypes = {
	displayCharts       : PropTypes.oneOfType([
		PropTypes.bool,
		PropTypes.string
	]).isRequired,
	onClickHideCharts   : PropTypes.func.isRequired,
	tabs                : PropTypes.arrayOf(PropTypes.shape({
		id   : PropTypes.string.isRequired,
		label: PropTypes.string.isRequired
	})),
	title               : PropTypes.string.isRequired
}


// WEBPACK FOOTER //
// ./src/component/ratios/modal-chart/index.js